/* src/app/shared/has-highlights/has-highlights.component.scss */
:host {
  display: flex;
  align-items: center;
}
.icon {
  height: 1.5rem;
  width: 1.5rem;
}
/*# sourceMappingURL=has-highlights.component.css.map */
